import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nzl5d6v: FaireProductEntity = {
  token: "p_5nzl5d6v",
  type: "product",
  name: "Holy Shiitakes Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4f3c618834000af1b20cc9862462561aa72ced3b20a26ed425afe8c66d28ca11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87653df3b8a00902d30854325d6debf11197075330cacacc734265189d25b177.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:05.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
